var React = require('react');

function StarNegative (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"d":"M0,32c0,17.7,14.3,32,32,32C32,46.3,17.7,32,0,32z","key":0}),React.createElement("path",{"d":"M32,0C14.3,0,0,14.3,0,32C17.7,32,32,17.7,32,0z","key":1}),React.createElement("path",{"d":"M32,64c17.7,0,32-14.3,32-32C46.3,32,32,46.3,32,64z","key":2}),React.createElement("path",{"d":"M64,32C64,14.3,49.7,0,32,0C32,17.7,46.3,32,64,32z","key":3})]));
}

StarNegative.defaultProps = {"x":"0px","y":"0px","viewBox":"0 0 64 64"};

module.exports = StarNegative;

StarNegative.default = StarNegative;
